export class SheetField {
  id: number
  kind: number
  part1: string
  part2: string
  part3: string
  question_content: string
  page: number
  allot: number
  allot_cache: number
  view_point_id: number
  scoring_type: number
  recog_type: number
  mark_count: number
  correct_mark_nos: number[]
  correct_mark_nos_text: string

  constructor(x: any) {
    this.id = x.id;
    this.kind = x.kind;
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.question_content = x.question_content;
    this.page = x.page;
    this.allot = x.allot;
    this.allot_cache = x.allot;
    this.view_point_id = x.view_point_id;
    this.scoring_type = x.scoring_type;
    this.recog_type = x.recog_type;
    this.mark_count = x.mark_count;
    this.correct_mark_nos = x.correct_mark_nos;
    if(this.correct_mark_nos){
      this.correct_mark_nos_text = x.correct_mark_nos.join(",");
    }
  }
}
